import { render, staticRenderFns } from "./MailDetail.vue?vue&type=template&id=a8bae504"
import script from "./MailDetail.vue?vue&type=script&lang=js"
export * from "./MailDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports